export enum CardVariants {
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary",
  quaternary = "quaternary",
  quinary = "quinary",
  senary = "senary",
  septenary = "septenary",
  default = "default",
}

export enum OffersDiscountCardVariants {
  primary = "primary",
  default = "default",
}
